<template>
  <div class="px-3 py-3 mb-5 col-24 col-md-11">
    <div class="col d-column">
      <h1 class="title pt-2 mb-0" v-text="$ml.get('integration')">
        Integração
      </h1>
      <h1 class="title">
        <span
          class="pb-2"
          v-text="$ml.get('receiveNotificationsAboutNewReports')"
          >Receba notificações sobre novos relatórios diretamente no seu slack e
          teams.</span
        >
      </h1>

      <div class="accordion" role="tablist">
        <!-- Gat -->
        <b-card no-body v-if="integrationList.includes('gat')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-gat
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>GAT</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-gat"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">GAT Webhooks</label>

                      <div class="">
                        <input
                          type="text"
                          v-model="gat_url"
                          class="form-control"
                          placeholder="https://your-domain.gat.digital/"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="integrationGatError && !$v.gat_url.minLength"
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationGatError && !gat_url"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font v-text="'Exemplo'"> </font>
                          <a
                            class="ml-1"
                            target="_blank"
                            rel="noopener noreferrer"
                            >https://your-domain.gat.digital</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <div style="position: relative">
                          <input
                            :type="showGatToken ? 'text' : 'password'"
                            v-model="gat_token"
                            class="form-control"
                            placeholder="Bearer BH7a73ed-f795-2021-962e-da6f579fd7BH"
                            maxlength="45"
                          />
                          <VueCustomTooltip
                            v-show="gat_token?.length"
                            class="login-ico"
                            style="position: absolute"
                          >
                            <svg
                              class="ico-20"
                              @click="showGatToken = !showGatToken"
                            >
                              <image
                                class="icon-eye"
                                v-show="showGatToken"
                                xlink:href="../../assets/icons/eye-slash.svg"
                                width="20"
                                height="20"
                              />
                              <image
                                class="icon-eye"
                                v-show="!showGatToken"
                                xlink:href="../../assets/icons/eye.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationGatError && !$v.gat_token.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationGatError && !gat_token"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.with('Token').get('questionsAboutUrl')"
                          >
                            Dúvidas sobre token ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://help.gat.digital/pt-BR/articles/5814793-como-obter-a-chave-de-api-gat-core"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>
                      <div class="mt-4 align-items-center">
                        <label
                          class="text-muted"
                          v-text="$ml.get('gatTagDescription')"
                          >Quais relatórios serão enviados para a plataforma
                          GAT?</label
                        >
                        <b-form-group>
                          <b-form-radio-group v-model="selectedGatIntegration">
                            <b-form-radio
                              class="align-center"
                              v-model="gatIntegrationOpt"
                              :value="{ id: 'all', name: 'all' }"
                              ><span
                                style="line-height: 1.5rem !important"
                                v-text="$ml.get('all')"
                              ></span
                            ></b-form-radio>
                            <b-form-radio
                              class="align-bottom"
                              v-model="gatIntegrationOpt"
                              :value="{ id: 'gat-tag', name: 'gat-tag' }"
                              ><span
                                style="line-height: 1.5rem !important"
                                v-text="$ml.get('gatTagOptDescription')"
                              ></span
                            ></b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                        <!-- <div class="mt-3">selectedGatIntegration: <strong>{{ selectedGatIntegration }}</strong></div> -->
                        <!-- <div class="mt-3">gatIntegrationOpt: <strong>{{ gatIntegrationOpt }}</strong></div> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row my-2">
                  <button @click="alterIntegration('gat')" class="btn btnForm">
                    <Spinner v-show="loadingBtn" />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('gat')"
                    :disabled="!gat_url || !gat_token"
                    class="btn btn-outline-extra m-0 ml-2"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Excluir</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Slack -->
        <b-card no-body v-if="integrationList.includes('slack')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-slack
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Slack</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-slack"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted"
                        >URL Slack Incoming Webhooks</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="https://hooks.slack.com/services"
                        v-model="slack_url"
                        maxlength="250"
                      />
                      <transition name="fade">
                        <label
                          v-if="
                            integrationSlackError && !$v.slack_url.minLength
                          "
                          class="lblError"
                          v-text="$ml.get('theWebhookIsNotValid')"
                          >O webhook não é válido!</label
                        >
                        <label
                          v-else-if="integrationSlackError && !slack_url"
                          class="lblError"
                          v-text="$ml.get('requiredField')"
                        >
                          Campo obrigatório
                        </label>
                      </transition>
                      <small class="row"
                        ><font v-text="$ml.get('anyQuestionsAboutIntegration')"
                          >Dúvidas sobre essa integração?</font
                        >
                        <a
                          class="ml-1"
                          href="https://api.slack.com/messaging/webhooks"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-text="$ml.get('clickHereToLearn')"
                          >Saiba mais</a
                        >
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('slack')"
                    class="btn btnForm m-0"
                  >
                    <Spinner v-show="loadingBtn" />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('slack')"
                    :disabled="!slack_url"
                    class="btn btn-outline-extra m-0 ml-2"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Teams -->
        <b-card no-body v-if="integrationList.includes('teams')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-teams
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Teams</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-teams"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted"
                        >URL Microsoft Teams Incoming Webhooks</label
                      >
                      <input
                        type="text"
                        v-model="teams_url"
                        class="form-control"
                        :placeholder="`https://${$ml.get(
                          'placeholderConfigTeams',
                        )}.environment.api.powerplatform.com/...`"
                      />
                      <transition name="fade">
                        <label
                          v-if="
                            integrationTeamsError && !$v.teams_url.minLength
                          "
                          class="lblError"
                          v-text="$ml.get('invalidUrlTeams')"
                          >A URL informada é inválida.</label
                        >
                        <label
                          v-else-if="integrationTeamsError && !teams_url"
                          class="lblError"
                          v-text="$ml.get('requiredField')"
                        >
                          Campo obrigatório
                        </label>
                      </transition>
                      <small class="row"
                        ><font v-text="$ml.get('anyQuestionsAboutIntegration')"
                          >Dúvidas sobre essa integração?</font
                        >
                        <a
                          class="ml-1"
                          href="https://support.microsoft.com/en-US/Workflows/send-messages-in-teams-using-incoming-webhooks"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-text="$ml.get('clickHereToLearn')"
                        >
                          Saiba mais</a
                        >
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('teams')"
                    class="btn btnForm m-0"
                  >
                    <Spinner v-show="loadingBtn" />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('teams')"
                    :disabled="!teams_url"
                    class="btn btn-outline-extra m-0 ml-2"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Google Chat -->
        <b-card
          no-body
          v-if="integrationList.includes('google_chat')"
          class="mb-2"
        >
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-gChat
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Google Chat</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-gChat"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted"
                        >URL Google Chat Incoming Webhooks</label
                      >
                      <input
                        type="text"
                        v-model="gChat_url"
                        class="form-control"
                        placeholder="https://chat.googleapis.com/v1/spaces/bug..."
                        maxlength="250"
                      />
                      <transition name="fade">
                        <label
                          v-if="
                            integrationGChatError && !$v.gChat_url.minLength
                          "
                          class="lblError"
                          v-text="$ml.get('theWebhookIsNotValid')"
                          >O webhook não é válido!
                        </label>
                        <label
                          v-else-if="integrationGChatError && !gChat_url"
                          class="lblError"
                          v-text="$ml.get('requiredField')"
                        >
                          Campo obrigatório
                        </label>
                      </transition>
                      <small class="row">
                        <font v-text="$ml.get('anyQuestionsAboutIntegration')"
                          >Dúvidas sobre essa integração?</font
                        >
                        <a
                          class="ml-1"
                          href="https://developers.google.com/chat/how-tos/webhooks"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-text="$ml.get('clickHereToLearn')"
                        >
                          Saiba mais
                        </a>
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('google chat')"
                    class="btn btnForm m-0"
                  >
                    <Spinner v-show="loadingBtn" />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('google chat')"
                    :disabled="!gChat_url"
                    class="btn btn-outline-extra m-0 ml-2"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Jira -->
        <b-card no-body v-if="integrationList.includes('jira')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-jira
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Jira Service Manager</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-jira"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">Jira Webhooks</label>

                      <div class="">
                        <input
                          type="text"
                          v-model="jira_url"
                          class="form-control"
                          placeholder="https://your-domain.atlassian.net/"
                          maxlength="400"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationJiraError && !$v.jira_url.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationJiraError && !jira_url"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório
                          </label>
                        </transition>
                        <small class="row"
                          ><font
                            v-text="
                              $ml.with('url Jira').get('questionsAboutUrl')
                            "
                          >
                            Dúvidas sobre url Jira ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://developer.atlassian.com/cloud/jira/service-desk/rest/intro/#authentication-for-other-integrations"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <div style="position: relative">
                          <input
                            :type="showJiraKey ? 'text' : 'password'"
                            v-model="jira_key"
                            class="form-control"
                            placeholder="BHIJ"
                            maxlength="400"
                          />
                          <VueCustomTooltip
                            v-show="jira_key?.length"
                            class="login-ico"
                            style="position: absolute"
                          >
                            <svg
                              class="ico-20"
                              @click="showJiraKey = !showJiraKey"
                            >
                              <image
                                class="icon-eye"
                                v-show="showJiraKey"
                                xlink:href="../../assets/icons/eye-slash.svg"
                                width="20"
                                height="20"
                              />
                              <image
                                class="icon-eye"
                                v-show="!showJiraKey"
                                xlink:href="../../assets/icons/eye.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationJiraError && !$v.jira_key.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationJiraError && !jira_key"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.with('Key').get('questionsAboutUrl')"
                          >
                            Dúvidas sobre Key ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://support.atlassian.com/jira-software-cloud/docs/what-is-an-issue/#Workingwithissues-Projectandissuekeys"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <input
                          type="text"
                          v-model="jira_email"
                          class="form-control"
                          placeholder="my-email@domain.com"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationJiraError && !$v.jira_email.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationJiraError && !jira_email"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.with('Jira').get('yourAccesEmail')"
                          >
                            Seu e-mail de acesso ao Jira</font
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <input
                          type="text"
                          v-model="jira_issue_type"
                          class="form-control"
                          placeholder="Task"
                          maxlength="100"
                        />
                        <transition name="fade">
                          <label
                            v-if="integrationJiraError"
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationJiraError && !jira_issue_type"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font v-text="$ml.get('jiraIssueType')">
                            Qual será o tipo da atividade que será cadastrada no
                            jira?</font
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <div style="position: relative">
                          <input
                            :type="showJiraToken ? 'text' : 'password'"
                            v-model="jira_token"
                            class="form-control"
                            placeholder="21V21LwAbb3izVgdGmc177BH"
                            maxlength="400"
                          />
                          <VueCustomTooltip
                            v-show="jira_token?.length"
                            class="login-ico"
                            style="position: absolute"
                          >
                            <svg
                              class="ico-20"
                              @click="showJiraToken = !showJiraToken"
                            >
                              <image
                                class="icon-eye"
                                v-show="showJiraToken"
                                xlink:href="../../assets/icons/eye-slash.svg"
                                width="20"
                                height="20"
                              />
                              <image
                                class="icon-eye"
                                v-show="!showJiraToken"
                                xlink:href="../../assets/icons/eye.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationJiraError && !$v.jira_token.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationJiraError && !jira_token"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.with('Token').get('questionsAboutUrl')"
                          >
                            Dúvidas sobre token ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://support.atlassian.com/atlassian-account/docs/manage-api-tokens-for-your-atlassian-account/"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                        <div class="custom-checkbox mt-4">
                          <input
                            type="checkbox"
                            id="checkTerms"
                            v-model="jira_is_auto"
                            name="check"
                          />
                          <label
                            class="form-check-label label-text"
                            for="checkTerms"
                          >
                            <font class="m-4"
                              >{{ $ml.get("automaticSendingToJira") }}
                              <strong>{{ $ml.get("jira") }}</strong></font
                            >
                          </label>
                        </div>
                        <CardInfoJira v-show="!jira_is_auto" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('jira')"
                    class="btn btnForm m-0"
                  >
                    <img
                      v-show="loadingBtn"
                      src="../../../src/assets/icons/spinner.svg"
                      class="ico-17 fa-spin"
                    />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('jira')"
                    :disabled="
                      !jira_url ||
                      !jira_key ||
                      !jira_email ||
                      !jira_token ||
                      !jira_issue_type
                    "
                    class="btn btn-outline-extra m-0 ml-2"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Zendesk -->
        <b-card no-body v-if="integrationList.includes('zendesk')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-zendesk
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Zendesk</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-zendesk"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">Zendesk Webhooks</label>

                      <div class="">
                        <input
                          type="text"
                          v-model="zendesk_url"
                          class="form-control"
                          placeholder="https://your-domain.zendesk.com/"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationZendeskError &&
                              !$v.zendesk_url.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationZendeskError && !zendesk_url"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="
                              $ml.with('url Zendesk').get('questionsAboutUrl')
                            "
                          >
                            Dúvidas sobre url Zendesk ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://developer.zendesk.com/documentation/ticketing/getting-started/zendesk-api-quick-start/"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <input
                          type="text"
                          v-model="zendesk_email"
                          class="form-control"
                          placeholder="my-email@domain.com"
                          maxlength="100"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationZendeskError &&
                              !$v.zendesk_email.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationZendeskError && !zendesk_email
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.with('Zendesk').get('yourAccesEmail')"
                          >
                            Seu e-mail de acesso ao Zendesk</font
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <div style="position: relative">
                          <input
                            :type="showZendeskToken ? 'text' : 'password'"
                            v-model="zendesk_token"
                            class="form-control"
                            placeholder="uBHwCeLqwfvX0TAECBIplEKASwFE20cxxvBbuuBH"
                            maxlength="45"
                          />
                          <VueCustomTooltip
                            v-show="zendesk_token?.length"
                            class="login-ico"
                            style="position: absolute"
                          >
                            <svg
                              class="ico-20"
                              @click="showZendeskToken = !showZendeskToken"
                            >
                              <image
                                class="icon-eye"
                                v-show="showZendeskToken"
                                xlink:href="../../assets/icons/eye-slash.svg"
                                width="20"
                                height="20"
                              />
                              <image
                                class="icon-eye"
                                v-show="!showZendeskToken"
                                xlink:href="../../assets/icons/eye.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationZendeskError &&
                              !$v.zendesk_token.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationZendeskError && !zendesk_token
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.with('Token').get('questionsAboutUrl')"
                          >
                            Dúvidas sobre token ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://support.zendesk.com/hc/pt-br/articles/4408889192858-Gera%C3%A7%C3%A3o-de-novo-token-da-API"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('zendesk')"
                    class="btn btnForm m-0"
                  >
                    <img
                      v-show="loadingBtn"
                      src="../../../src/assets/icons/spinner.svg"
                      class="ico-17 fa-spin"
                    />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('zendesk')"
                    :disabled="!zendesk_url || !zendesk_email || !zendesk_token"
                    class="btn btn-outline-extra m-0 ml-2"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Servicenow -->
        <b-card
          no-body
          v-if="integrationList.includes('servicenow')"
          class="mb-2"
        >
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-servicenow
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Servicenow</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-servicenow"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">Servicenow Webhooks</label>

                      <div class="">
                        <input
                          type="text"
                          :disabled="servicenow_token ? true : false"
                          v-model="servicenow_url"
                          class="form-control"
                          placeholder="https://your-domain.service-now.com/"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationServicenowError &&
                              !$v.servicenow_url.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationServicenowError && !servicenow_url
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font v-text="'Exemplo'"> </font>
                          <a
                            class="ml-1"
                            target="_blank"
                            rel="noopener noreferrer"
                            >https://your-domain.service-now.com</a
                          >
                        </small>
                      </div>

                      <div class="mt-4" v-if="servicenow_token">
                        <input
                          type="text"
                          :disabled="servicenow_token"
                          v-model="servicenow_token"
                          class="form-control"
                          placeholder="admin"
                          maxlength="100"
                        />
                        <small class="row">
                          <font v-text="'Token de integração servicenow!'">
                          </font>
                        </small>
                      </div>

                      <div class="mt-4" v-if="!servicenow_token">
                        <input
                          type="text"
                          v-model="servicenow_username"
                          class="form-control"
                          placeholder="User name"
                          maxlength="100"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationServicenowError &&
                              !$v.servicenow_username.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationServicenowError && !servicenow_username
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                      </div>

                      <div class="mt-4" v-if="!servicenow_token">
                        <div style="position: relative">
                          <input
                            :type="showSerivenowPassword ? 'text' : 'password'"
                            v-model="servicenow_password"
                            class="form-control"
                            placeholder="Password"
                            maxlength="45"
                          />
                          <VueCustomTooltip
                            v-show="servicenow_password?.length"
                            class="login-ico"
                            style="position: absolute"
                          >
                            <svg
                              class="ico-20"
                              @click="
                                showSerivenowPassword = !showSerivenowPassword
                              "
                            >
                              <image
                                class="icon-eye"
                                v-show="showSerivenowPassword"
                                xlink:href="../../assets/icons/eye-slash.svg"
                                width="20"
                                height="20"
                              />
                              <image
                                class="icon-eye"
                                v-show="!showSerivenowPassword"
                                xlink:href="../../assets/icons/eye.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationServicenowError &&
                              !$v.servicenow_password.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationServicenowError && !servicenow_password
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('servicenow')"
                    class="btn btnForm m-0 mr-2"
                    v-if="!servicenow_token"
                  >
                    <img
                      v-show="loadingBtn"
                      src="../../../src/assets/icons/spinner.svg"
                      class="ico-17 fa-spin"
                    />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('servicenow')"
                    :disabled="!servicenow_url"
                    class="btn btn-outline-extra m-0"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Trello -->
        <b-card no-body v-if="integrationList.includes('trello')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-trello
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Trello</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-trello"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">Trello Webhooks</label>

                      <div>
                        <div style="position: relative">
                          <input
                            :type="showTrelloKey ? 'text' : 'password'"
                            v-model="trello_key"
                            class="form-control"
                            placeholder="Key"
                            maxlength="200"
                          />
                          <VueCustomTooltip
                            v-show="trello_key?.length"
                            class="login-ico"
                            style="position: absolute"
                          >
                            <svg
                              class="ico-20"
                              @click="showTrelloKey = !showTrelloKey"
                            >
                              <image
                                class="icon-eye"
                                v-show="showTrelloKey"
                                xlink:href="../../assets/icons/eye-slash.svg"
                                width="20"
                                height="20"
                              />
                              <image
                                class="icon-eye"
                                v-show="!showTrelloKey"
                                xlink:href="../../assets/icons/eye.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationTrelloError && !$v.trello_key.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationTrelloError && !trello_key"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row">
                          <font
                            v-text="$ml.with('Key').get('questionsAboutUrl')"
                            >Dúvidas sobre Key ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://developer.atlassian.com/cloud/trello/guides/rest-api/api-introduction/"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <div style="position: relative">
                          <input
                            :type="showTrelloToken ? 'text' : 'password'"
                            v-model="trello_token"
                            class="form-control"
                            placeholder="Token"
                            maxlength="100"
                          />
                          <VueCustomTooltip
                            v-show="trello_token?.length"
                            class="login-ico"
                            style="position: absolute"
                          >
                            <svg
                              class="ico-20"
                              @click="showTrelloToken = !showTrelloToken"
                            >
                              <image
                                class="icon-eye"
                                v-show="showTrelloToken"
                                xlink:href="../../assets/icons/eye-slash.svg"
                                width="20"
                                height="20"
                              />
                              <image
                                class="icon-eye"
                                v-show="!showTrelloToken"
                                xlink:href="../../assets/icons/eye.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationTrelloError &&
                              !$v.trello_token.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationTrelloError && !trello_token"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row">
                          <font
                            v-text="$ml.with('Token').get('questionsAboutUrl')"
                            >Dúvidas sobre Token ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://developer.atlassian.com/cloud/trello/guides/rest-api/authorization/"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('trello')"
                    class="btn btnForm m-0 mr-2"
                  >
                    <img
                      v-show="loadingBtn"
                      src="../../../src/assets/icons/spinner.svg"
                      class="ico-17 fa-spin"
                    />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('trello')"
                    class="btn btn-outline-extra m-0"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Azure DevOps -->
        <b-card
          no-body
          v-if="integrationList.includes('azureDevOps')"
          class="mb-2"
        >
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-AzureDevOps
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Azure DevOps</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-AzureDevOps"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">Azure DevOps Webhooks</label>

                      <div>
                        <input
                          type="text"
                          v-model="azureDevOps_organization"
                          class="form-control"
                          placeholder="Organization"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationAzureDevOpsError &&
                              !$v.azureDevOps_organization.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationAzureDevOpsError &&
                              !azureDevOps_organization
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row">
                          <font
                            v-text="
                              $ml.with('Organization').get('questionsAboutUrl')
                            "
                            >Dúvidas sobre Organization ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://learn.microsoft.com/en-us/azure/devops/organizations/accounts/create-organization?view=azure-devops"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <input
                          type="text"
                          v-model="azureDevOps_project"
                          class="form-control"
                          placeholder="Project"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationAzureDevOpsError &&
                              !$v.azureDevOps_project.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationAzureDevOpsError &&
                              !azureDevOps_project
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row">
                          <font
                            v-text="
                              $ml.with('Project').get('questionsAboutUrl')
                            "
                            >Dúvidas sobre Project ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://learn.microsoft.com/en-us/azure/devops/organizations/projects/about-projects?view=azure-devops"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <div style="position: relative">
                          <input
                            :type="showAzureToken ? 'text' : 'password'"
                            v-model="azureDevOps_token"
                            class="form-control"
                            placeholder="Token full access or Read & write Work Items"
                            maxlength="100"
                          />
                          <VueCustomTooltip
                            v-show="azureDevOps_token?.length"
                            class="login-ico"
                            style="position: absolute"
                          >
                            <svg
                              class="ico-20"
                              @click="showAzureToken = !showAzureToken"
                            >
                              <image
                                class="icon-eye"
                                v-show="showAzureToken"
                                xlink:href="../../assets/icons/eye-slash.svg"
                                width="20"
                                height="20"
                              />
                              <image
                                class="icon-eye"
                                v-show="!showAzureToken"
                                xlink:href="../../assets/icons/eye.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationAzureDevOpsError &&
                              !$v.azureDevOps_token.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationAzureDevOpsError && !azureDevOps_token
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row">
                          <font
                            v-text="$ml.with('Token').get('questionsAboutUrl')"
                            >Dúvidas sobre Token ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://learn.microsoft.com/pt-br/azure/devops/organizations/accounts/use-personal-access-tokens-to-authenticate?view=azure-devops&tabs=Windows"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('azureDevOps')"
                    class="btn btnForm m-0 mr-2"
                  >
                    <img
                      v-show="loadingBtn"
                      src="../../../src/assets/icons/spinner.svg"
                      class="ico-17 fa-spin"
                    />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('azureDevOps')"
                    class="btn btn-outline-extra m-0"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Wiz -->
        <b-card no-body v-if="integrationList.includes('wiz')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-wiz
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Wiz</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-wiz"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="info-box mb-4">
                  <div class="info-header">
                    <img src="../../assets/svg/info-fill.svg" width="18" />
                    <strong v-text="$ml.get('titleWizInfoBox')"
                      >Como concluir a integração com o Wiz</strong
                    >
                  </div>
                  <ol class="info-list">
                    <li v-text="$ml.get('wizInfoStep1')">Informe suas credenciais do Wiz.</li>
                    <!-- <li v-text="$ml.get('wizInfoStep2')">Busque os projetos disponíveis.</li> -->
                    <!-- <li v-text="$ml.get('wizInfoStep3')">Selecione o projeto desejado.</li> -->
                    <li v-text="$ml.get('wizInfoStep4')">Clique em Conectar para finalizar a integração.</li>
                  </ol>
                </div>

                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">Client ID</label>
                      <input
                        type="text"
                        v-model="wiz_client_id"
                        class="form-control"
                        placeholder="Client ID"
                        maxlength="200"
                      />
                      <transition name="fade">
                        <label
                          v-if="
                            integrationWizError && !$v.wiz_client_id.minLength
                          "
                          class="lblError"
                          v-text="$ml.get('invalidData')"
                          >Dados inválidos</label
                        >
                        <label
                          v-else-if="integrationWizError && !wiz_client_id"
                          class="lblError"
                          v-text="$ml.get('requiredField')"
                        >
                          Campo obrigatório</label
                        >
                      </transition>
                    </div>

                    <div class="mt-4">
                      <label class="text-muted">Client Secret</label>
                      <div style="position: relative">
                        <input
                          :type="showWizSecret ? 'text' : 'password'"
                          v-model="wiz_client_secret"
                          class="form-control"
                          placeholder="Client Secret"
                          maxlength="200"
                        />
                        <VueCustomTooltip
                          v-show="wiz_client_secret?.length"
                          class="login-ico"
                          style="position: absolute"
                        >
                          <svg
                            class="ico-20"
                            @click="showWizSecret = !showWizSecret"
                          >
                            <image
                              class="icon-eye"
                              v-show="showWizSecret"
                              xlink:href="../../assets/icons/eye-slash.svg"
                              width="20"
                              height="20"
                            />
                            <image
                              class="icon-eye"
                              v-show="!showWizSecret"
                              xlink:href="../../assets/icons/eye.svg"
                              width="20"
                              height="20"
                            />
                          </svg>
                        </VueCustomTooltip>
                      </div>
                      <transition name="fade">
                        <label
                          v-if="
                            integrationWizError &&
                            !$v.wiz_client_secret.minLength
                          "
                          class="lblError"
                          v-text="$ml.get('invalidData')"
                          >Dados inválidos</label
                        >
                        <label
                          v-else-if="integrationWizError && !wiz_client_secret"
                          class="lblError"
                          v-text="$ml.get('requiredField')"
                        >
                          Campo obrigatório</label
                        >
                      </transition>
                    </div>

                    <div class="mt-4 mb-4">
                      <label class="text-muted">Client Wiz URL</label>
                      <input
                        type="text"
                        v-model="wiz_client_url"
                        class="form-control"
                        placeholder="https://your-domain.wiz.io/"
                        maxlength="500"
                      />
                      <transition name="fade">
                        <label
                          v-if="
                            integrationWizError && !$v.wiz_client_url.minLength
                          "
                          class="lblError"
                          v-text="$ml.get('invalidData')"
                          >Dados inválidos</label
                        >
                        <label
                          v-else-if="integrationWizError && !wiz_client_url"
                          class="lblError"
                          v-text="$ml.get('requiredField')"
                        >
                          Campo obrigatório</label
                        >
                      </transition>
                      <small class="row">
                        <font v-text="'Exemplo'"> </font>
                        <a
                          class="ml-1"
                          target="_blank"
                          rel="noopener noreferrer"
                          >https://your-domain.wiz.io</a
                        >
                      </small>
                    </div>

                    <!-- <div class="mt-4 mb-4">
                      <button
                        @click="getAllWizProjects"
                        class="btn btn-custom-wiz"
                        :disabled="loadingWizProjects"
                      >
                        <Spinner v-show="loadingWizProjects" color="purple" />
                        <img
                          v-show="!loadingWizProjects"
                          src="../../assets/icons/search-wiz.svg"
                          class="ico-16 mr-1"
                        />
                        <span v-show="!loadingWizProjects" v-text="$ml.get('search')"
                          >Pesquisar</span
                        >
                      </button>
                    </div> -->

                    <!-- <div class="mb-4" v-if="wiz_projects.length">
                      <label class="text-muted">Projeto</label>
                      <multiselect
                        v-model="selectedProjectId"
                        :options="wiz_projects"
                        :placeholder="$ml.get('selectWizProject')"
                        :searchable="true"
                        label="name"
                        track-by="id"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        :preselect-first="true"
                        :multiple="false"
                        :disabled="loadingWizProjects || !wiz_projects.length"
                      >
                      </multiselect>
                    </div> -->
                  </div>
                </div>

                <div class="row my-2 d-flex align-items-center">
                  <button
                    @click="alterIntegration('wiz')"
                    class="btn btnForm m-0 mr-2"
                    :disabled="loadingBtn"
                  >
                    <Spinner v-show="loadingBtn" />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>

                  <button
                    @click="removeIntegration('wiz')"
                    class="btn btn-outline-extra m-0"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- External API -->
        <b-card no-body v-if="can_access_ext_api" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-ext-api
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>External API</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-ext-api"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">API Token</label>
                      <div class="form-group">
                        <div style="position: relative">
                          <input
                            :type="showApiToken ? 'text' : 'password'"
                            class="form-control"
                            v-model="apiToken"
                            name="password"
                            :placeholder="$ml.get('placeholderTokenCompany')"
                          />
                          <VueCustomTooltip
                            v-show="apiToken?.length"
                            class="login-ico"
                            style="position: absolute"
                          >
                            <svg
                              class="ico-20"
                              @click="showApiToken = !showApiToken"
                            >
                              <image
                                class="icon-eye"
                                v-show="showApiToken"
                                xlink:href="../../assets/icons/eye-slash.svg"
                                width="20"
                                height="20"
                              />
                              <image
                                class="icon-eye"
                                v-show="!showApiToken"
                                xlink:href="../../assets/icons/eye.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                      </div>
                      <div>
                        <transition name="fade">
                          <label
                            v-if="tokenError"
                            class="lblError"
                            v-text="$ml.get('errorToken')"
                            >O token deve conter no mínimo 20 caracteres e no
                            máximo 500 caracteres!</label
                          >
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('external-api')"
                    class="btn btnForm"
                  >
                    <Spinner v-show="loadingBtn" />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>

                  <button
                    @click="deleteCompanyToken()"
                    class="btn btn-outline-extra m-0 ml-2"
                    :disabled="!thereIsToken"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Excluir</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { minLength, required } from "vuelidate/lib/validators";
import CompanyService from "../../services/company.service";
import CardInfoJira from "../../components/CardInfoJira.vue";
import {
  executeRecaptchaV3,
  RECAPTCHA_V3_ACTIONS,
} from "../../helpers/recaptchaV3.js";
export default {
  props: ["integrationList"],

  components: {
    CardInfoJira,
  },
  data() {
    return {
      slack_url: "",
      teams_url: "",
      gChat_url: "",

      jira_url: "",
      jira_key: "",
      jira_is_auto: false,
      jira_email: "",
      jira_token: "",
      jira_issue_type: "",

      zendesk_url: "",
      zendesk_email: "",
      zendesk_token: "",

      servicenow_url: "",
      servicenow_token: "",
      servicenow_username: "",
      servicenow_password: "",

      gat_url: "",
      gat_token: "",
      selectedGatIntegration: { id: "all", name: "all" },
      gatIntegrationOpt: "",

      trello_key: "",
      trello_token: "",

      azureDevOps_organization: "",
      azureDevOps_project: "",
      azureDevOps_token: "",

      wiz_client_id: "",
      wiz_client_secret: "",
      wiz_client_url: "",
      // wiz_projects: [],
      // selectedProjectId: null,
      // loadingWizProjects: false,

      loadingBtn: false,
      loadingRemoveBtn: false,

      integrationGatError: false,
      integrationSlackError: false,
      integrationTeamsError: false,
      integrationGChatError: false,
      integrationJiraError: false,
      integrationZendeskError: false,
      integrationServicenowError: false,
      integrationTrelloError: false,
      integrationAzureDevOpsError: false,
      integrationWizError: false,

      accordionSlack: null,

      apiToken: "",
      tokenError: false,
      thereIsToken: false,
      can_access_ext_api: "",

      showApiToken: false,
      showGatToken: false,
      showJiraKey: false,
      showJiraToken: false,
      showZendeskToken: false,
      showSerivenowPassword: false,
      showTrelloKey: false,
      showTrelloToken: false,
      showAzureToken: false,
      showWizSecret: false,
    };
  },

  validations: {
    slack_url: { required, minLength: minLength(30) },
    teams_url: { required, minLength: minLength(120) },
    gChat_url: { required, minLength: minLength(30) },

    jira_url: { required, minLength: minLength(20) },
    jira_key: { required, minLength: minLength(2) },
    jira_email: { required, minLength: minLength(10) },
    jira_issue_type: { required, minLength: minLength(1) },
    jira_token: { required, minLength: minLength(10) },

    zendesk_url: { required, minLength: minLength(20) },
    zendesk_email: { required, minLength: minLength(10) },
    zendesk_token: { required, minLength: minLength(10) },

    servicenow_url: { required, minLength: minLength(20) },
    servicenow_username: { required, minLength: minLength(3) },
    servicenow_password: { required, minLength: minLength(3) },

    gat_url: { required, minLength: minLength(20) },
    gat_token: { required, minLength: minLength(10) },
    selectedGatIntegration: { required },

    trello_key: { required, minLength: minLength(10) },
    trello_token: { required, minLength: minLength(20) },

    azureDevOps_organization: { required, minLength: minLength(3) },
    azureDevOps_project: { required, minLength: minLength(3) },
    azureDevOps_token: { required, minLength: minLength(20) },

    wiz_client_id: { required, minLength: minLength(3) },
    wiz_client_secret: { required, minLength: minLength(3) },
    wiz_client_url: { required, minLength: minLength(10) },
  },

  created() {
    this.changeIntegration();
  },
  mounted() {
    this.can_access_ext_api = this.$store.getters["getCanAcessExtApi"];
  },
  methods: {
    changeIntegration() {
      CompanyService.getCompanyIntegration().then((response) => {
        let resp = response.data;

        this.slack_url = resp.integration.webhook?.slack_url;
        this.teams_url = resp.integration.webhook?.teams_url;
        this.gChat_url = resp.integration.webhook?.gChat_url;

        this.jira_url = resp.integration.webhook?.jira?.url_jira ?? "";
        this.jira_key = resp.integration.webhook?.jira?.key ?? "";
        this.jira_email = resp.integration.webhook?.jira?.username ?? "";
        this.jira_issue_type =
          resp.integration.webhook?.jira?.issue_type ?? "Task";
        this.jira_token = resp.integration.webhook?.jira?.token ?? "";
        this.jira_is_auto = resp.integration.webhook?.jira?.is_auto ?? false;
        this.zendesk_url = resp.integration.webhook?.zendesk?.zendesk_url ?? "";
        this.zendesk_email = resp.integration.webhook?.zendesk?.username ?? "";
        this.zendesk_token = resp.integration.webhook?.zendesk?.token ?? "";
        this.wiz_client_id = resp.integration.webhook?.wiz?.client_id_wiz ?? "";
        this.wiz_client_secret = resp.integration.webhook?.wiz?.client_secret_wiz ?? "";
        this.wiz_client_url = resp.integration.webhook?.wiz?.url_wiz ?? "";
        // this.selectedProjectId = resp.integration.webhook?.wiz?.default_project_id_wiz ?? "";

        this.servicenow_url =
          resp.integration.webhook?.servicenow?.url_servicenow ?? "";
        this.servicenow_token =
          resp.integration.webhook?.servicenow?.token ?? "";
        this.servicenow_username =
          resp.integration.webhook?.servicenow?.username ?? "";
        this.servicenow_password =
          resp.integration.webhook?.servicenow?.password ?? "";

        this.gat_url = resp.integration.webhook?.gat?.gat_url ?? "";
        this.gat_token = resp.integration.webhook?.gat?.token ?? "";
        this.selectedGatIntegration =
          resp.integration.webhook?.gat?.use_triage_tag == true
            ? { id: "gat-tag", name: "gat-tag" }
            : { id: "all", name: "all" };
        this.apiToken = resp?.integration.ext_token;
        this.thereIsToken = resp?.integration.ext_token ? true : false;
        this.trello_key = resp.integration.webhook?.trello?.key ?? "";
        this.trello_token = resp.integration.webhook?.trello?.token ?? "";

        this.azureDevOps_organization =
          resp.integration.webhook?.azureDevOps?.organization ?? "";
        this.azureDevOps_project =
          resp.integration.webhook?.azureDevOps?.project ?? "";
        this.azureDevOps_token =
          resp.integration.webhook?.azureDevOps?.token ?? "";

        // if(this.selectedProjectId){
        //   this.getAllWizProjects();
        // }
      });
    },

    async alterIntegration(integration) {
      var self = this;

      this.integrationGatError = false;
      this.integrationSlackError = false;
      this.integrationTeamsError = false;
      this.integrationGChatError = false;
      this.integrationJiraError = false;
      this.integrationZendeskError = false;
      this.integrationServicenowError = false;
      this.integrationTrelloError = false;
      this.integrationAzureDevOpsError = false;
      this.integrationWizError = false;
      this.tokenError = false;

      // stop here if form is invalid
      this.$v.$touch();

      if (
        integration == "gat" &&
        (this.$v.gat_url.$invalid || this.$v.gat_token.$invalid)
      ) {
        this.integrationGatError = true;
        return;
      }

      if (integration == "slack" && this.$v.slack_url.$invalid) {
        this.integrationSlackError = true;
        return;
      }

      if (integration == "teams" && this.$v.teams_url.$invalid) {
        this.integrationTeamsError = true;
        return;
      }

      if (integration == "google chat" && this.$v.gChat_url.$invalid) {
        this.integrationGChatError = true;
        return;
      }

      if (
        integration == "jira" &&
        (this.$v.jira_url.$invalid ||
          this.$v.jira_key.$invalid ||
          this.$v.jira_email.$invalid ||
          this.$v.jira_issue_type.$invalid ||
          this.$v.jira_token.$invalid)
      ) {
        this.integrationJiraError = true;
        return;
      }

      if (
        integration == "zendesk" &&
        (this.$v.zendesk_url.$invalid ||
          this.$v.zendesk_email.$invalid ||
          this.$v.zendesk_token.$invalid)
      ) {
        this.integrationZendeskError = true;
        return;
      }

      if (
        integration == "servicenow" &&
        (this.$v.servicenow_url.$invalid ||
          this.$v.servicenow_username.$invalid ||
          this.$v.servicenow_password.$invalid)
      ) {
        this.integrationServicenowError = true;
        return;
      }

      if (
        integration == "trello" &&
        (this.$v.trello_key.$invalid || this.$v.trello_token.$invalid)
      ) {
        this.integrationTrelloError = true;
        return;
      }

      if (
        integration == "azureDevOps" &&
        (this.$v.azureDevOps_organization.$invalid ||
          this.$v.azureDevOps_project.$invalid ||
          this.$v.azureDevOps_project.$invalid)
      ) {
        this.integrationAzureDevOpsError = true;
        return;
      }

      if (
        integration == "wiz" &&
        (this.$v.wiz_client_id.$invalid ||
         this.$v.wiz_client_secret.$invalid|| 
         this.$v.wiz_client_url.$invalid
        )
      ) {
        this.integrationWizError = true;
        return;
      }

      this.loadingBtn = true;

      let payload = {};

      payload.recaptchaV3Token = await executeRecaptchaV3(
        RECAPTCHA_V3_ACTIONS.INTEGRATION,
      );
      if (integration == "slack") {
        payload.slack_url = this.slack_url;
      }

      if (integration == "teams") {
        payload.teams_url = this.teams_url;
      }

      if (integration == "google chat") {
        payload.gChat_url = this.gChat_url;
      }

      if (integration == "jira") {
        payload.url_jira = this.jira_url;
        payload.key = this.jira_key;
        payload.username = this.jira_email;
        payload.issue_type = this.jira_issue_type;
        payload.token = this.jira_token;
        payload.is_auto = this.jira_is_auto;
      }

      if (integration == "zendesk") {
        payload.url_zendesk = this.zendesk_url;
        payload.username = this.zendesk_email;
        payload.token = this.zendesk_token;
      }

      if (integration == "servicenow") {
        payload.url_servicenow = this.servicenow_url;
        payload.username = this.servicenow_username;
        payload.password = this.servicenow_password;
      }

      if (integration == "gat") {
        payload.url_gat = this.gat_url;
        payload.token = this.gat_token;
        payload.use_triage_tag =
          this.selectedGatIntegration.id == "all" ? "no" : "yes";
      }
      if (integration == "external-api") {
        if (this.apiToken?.length < 20) {
          this.tokenError = true;
          this.loadingBtn = false;
          return;
        }
        payload.ext_token = this.apiToken;
      }

      if (integration == "trello") {
        payload.key = this.trello_key;
        payload.token = this.trello_token;
      }

      if (integration == "azureDevOps") {
        payload.organization = this.azureDevOps_organization;
        payload.project = this.azureDevOps_project;
        payload.token = this.azureDevOps_token;
      }

      if (integration === "wiz") {
        payload.url_wiz = this.wiz_client_url
        payload.client_id_wiz = this.wiz_client_id;
        payload.client_secret_wiz = this.wiz_client_secret;
        // payload.default_project_id_wiz = this.selectedProjectId.id
      }

      payload.integration = integration;

      CompanyService.putCompanyIntegration(payload).then(
        (response) => {
          if (response.data == "limit_exceeded") {
            self.verifyPlan();
            this.loadingBtn = false;
            return;
          }
          this.changeIntegration();
          Swal.fire({
            icon: "success",
            title: self.$ml.get("dataChanged"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.loadingBtn = false;
        },
        (error) => {
          this.loadingBtn = false;

          if (error.response.data.message) {
            Swal.fire({
              icon: "warning",
              title: self.$ml
                .with(integration.toUpperCase())
                .get("invalidRegistrationData"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
            });
          } else {
            Swal.fire({
              icon: "warning",
              title: self.$ml.get("unableToCompleteThisRequest"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
            });
          }
        },
      );
    },

    async removeIntegration(integration) {
      var self = this;

      this.integrationGatError = false;
      this.integrationSlackError = false;
      this.integrationTeamsError = false;
      this.integrationGChatError = false;
      this.integrationJiraError = false;
      this.integrationZendeskError = false;
      this.integrationServicenowError = false;

      let payload = {};

      payload.recaptchaV3Token = await executeRecaptchaV3(
        RECAPTCHA_V3_ACTIONS.REMOVE_INTEGRATION,
      );

      payload.integration = integration;

      Swal.fire({
        html: `<h4 class="m-2">${self.$ml
          .with(self.$ml.get("integration"))
          .get("doYouReallyWantToRemoveThis")}</h4>`,
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        customClass: {
          cancelButton: "btn-outline-extra",
        },
        confirmButtonText: self.$ml.get("remove"),
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          self.loadingRemoveBtn = true;

          CompanyService.deleteCompanyIntegration(payload).then(
            (response) => {
              if (response.data == "limit_exceeded") {
                self.verifyPlan();
                this.loadingRemoveBtn = false;
                return;
              }
              this.changeIntegration();
              Swal.fire({
                icon: "success",
                title: self.$ml.get("removed"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              this.loadingRemoveBtn = false;
            },
            (error) => {
              this.loadingRemoveBtn = false;

              if (
                error.response.data.message === "Captcha does not authorize"
              ) {
                Swal.fire({
                  icon: "warning",
                  title: self.$ml.get("errorCaptcha"),
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 5000,
                });
              } else {
                Swal.fire({
                  icon: "warning",
                  title: self.$ml.get("unableToCompleteThisRequest"),
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 5000,
                });
              }
            },
          );
        }
      });
    },

    async verifyPlan() {
      var self = this;
      Swal.fire({
        icon: "info",
        html: `<h3 class="mb-2">${self.$ml.get("integrationsNotAvailable")}<h3> 
        <h5 class="mb-2">${self.$ml.get(
          "toAddTheseIntegrations",
        )} <a href="/account?plans">${self.$ml.get("here")}</a>  
        </h5>`,
        showConfirmButton: false,
        timer: 10000,
      });
    },
    async deleteCompanyToken() {
      const recaptchaV3Token = await executeRecaptchaV3(
        RECAPTCHA_V3_ACTIONS.REMOVE_INTEGRATION,
      );
      CompanyService.deleteCompanyToken({ recaptchaV3Token })
        .then((response) => {
          if (response.data === "token removido!") {
            Swal.fire({
              icon: "success",
              title: this.$ml.get("swalTokenRemoved"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            this.apiToken = "";
            this.changeIntegration();
          }
        })
        .catch((error) => {
          if (error.response.data.message === "Captcha does not authorize") {
            Swal.fire({
              icon: "warning",
              title: self.$ml.get("errorCaptcha"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.lblError {
  position: relative;
}
.angle-right {
  -ms-transform: rotate(90deg); /* IE 9 */
  transform: rotate(90deg);
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.login-ico {
  position: absolute;
  right: 7px;
  top: 20%;
}
.icon-eye {
  width: 99%;
}

.form-check-label {
  cursor: pointer;
  color: #666;
  font-size: 15px;
  margin-left: -12px;
}

/*Custom checkboxes style*/
.custom-checkbox input[type="checkbox"] + .label-text:before {
  content: "";
  text-transform: none;
  line-height: 0.8;
  display: inline-block;
  border-radius: 3px;
  border: #730ca8 1px solid;
  padding: 7px;
  position: absolute;
}
.custom-checkbox input[type="checkbox"]:checked + .label-text:before {
  content: "✓";
  color: #730ca8;
  border: #730ca8 1px solid;
  animation: effect 250ms ease-in;
  padding: 1px;
}

.info-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 4px solid #6c757d;
  border-radius: 8px;
  padding: 14px 16px;
  font-size: 13px;
  color: #1e293b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.info-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  font-size: 13px;
  color: #0f172a;
}
.info-list {
  margin: 0;
  padding-left: 18px;
  line-height: 1.6;
  color: #334155;
}
.info-list li {
  margin-bottom: 2px;
}
.btn-custom-wiz {
  color: #730ca8 !important;
  background-color: #fff !important;
}
</style>
